'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasl';
var iconName = 'phone';
var width = 512;
var height = 512;
var aliases = [128222,128379];
var unicode = 'f095';
var svgPathData = 'M167.2 216L224 160 128 0 0 64 0 80C0 318.6 193.4 512 432 512l16 0 64-128-160-96-56 56.8C236.8 322 190 275.2 167.2 216zM357.1 328.4l113 67.8-41.9 83.8C210.3 478 34 301.7 32 83.8l83.8-41.9 67.8 113c-29.9 29.5-47.8 47.2-53.8 53.1l7.5 19.6c26 67.6 79.5 121.1 147.1 147.1l19.6 7.5c5.9-6 23.6-23.9 53-53.8z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faPhone = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;